import React from 'react';
export const TimestampRenderer = React.memo((props) => {
    const { block } = props;
    return (React.createElement("span", { "data-inline-block": block.id, contentEditable: false, style: { color: 'red' } }, block.data.ts.toISOString()));
});
